// extracted by mini-css-extract-plugin
export default {"progress":"ProgressCard_progress__yBq-M"};